module.exports = __webpack_public_path__ + "img/indu_11.ab557867.png";